/**
 * Commons sea level — SEA_LEVEL_M clamped below the LOWEST seeded settlement
 * site (minus a beach margin), so no settlement the seed placed can ever end
 * up underwater no matter how the continental noise falls. Sites are
 * seed-derived, so every client computes the identical level. Memoized per
 * seed (312 terrainHeight samples once).
 */
import { SEA_LEVEL_M } from '@shared/constants.js';
import { settlementSites } from '@shared/settlements.js';
import { terrainHeight } from '@shared/terrain.js';

/** Beach margin (m) kept between the lowest settlement and the waterline. */
const SETTLEMENT_MARGIN_M = 8;

const cache = new Map<string, number>();

export function commonsSeaLevel(seed: string): number {
  let level = cache.get(seed);
  if (level === undefined) {
    let minSite = Infinity;
    for (const s of settlementSites(seed)) {
      const h = terrainHeight(seed, s.centerX, s.centerZ);
      if (h < minSite) minSite = h;
    }
    level = Math.min(SEA_LEVEL_M, minSite - SETTLEMENT_MARGIN_M);
    cache.set(seed, level);
  }
  return level;
}
